<template>
  <p class="mt-1 text-sm text-red-500">
    <slot />
  </p>
</template>
